export const options1 = [



    {
        "value": "浙江省",
        "label": "浙江省",
        "children": [{
            "value": "杭州市",
            "label": "杭州市",
            "children": [{
                "value": "上城区",
                "label": "上城区"
            }, {
                "value": "下城区",
                "label": "下城区"
            }, {
                "value": "江干区",
                "label": "江干区"
            }, {
                "value": "拱墅区",
                "label": "拱墅区"
            }, {
                "value": "西湖区",
                "label": "西湖区"
            }, {
                "value": "滨江区",
                "label": "滨江区"
            }, {
                "value": "萧山区",
                "label": "萧山区"
            }, {
                "value": "余杭区",
                "label": "余杭区"
            }, {
                "value": "富阳区",
                "label": "富阳区"
            }, {
                "value": "桐庐县",
                "label": "桐庐县"
            }, {
                "value": "淳安县",
                "label": "淳安县"
            }, {
                "value": "建德市",
                "label": "建德市"
            }, {
                "value": "临安市",
                "label": "临安市"
            }]
        }, {
            "value": "宁波市",
            "label": "宁波市",
            "children": [{
                "value": "海曙区",
                "label": "海曙区"
            }, {
                "value": "江北区",
                "label": "江北区"
            }, {
                "value": "北仑区",
                "label": "北仑区"
            }, {
                "value": "镇海区",
                "label": "镇海区"
            }, {
                "value": "鄞州区",
                "label": "鄞州区"
            }, {
                "value": "象山县",
                "label": "象山县"
            }, {
                "value": "宁海县",
                "label": "宁海县"
            }, {
                "value": "余姚市",
                "label": "余姚市"
            }, {
                "value": "慈溪市",
                "label": "慈溪市"
            }, {
                "value": "奉化区",
                "label": "奉化区"
            }]
        }, {
            "value": "温州市",
            "label": "温州市",
            "children": [{
                "value": "鹿城区",
                "label": "鹿城区"
            }, {
                "value": "龙湾区",
                "label": "龙湾区"
            }, {
                "value": "瓯海区",
                "label": "瓯海区"
            }, {
                "value": "洞头区",
                "label": "洞头区"
            }, {
                "value": "永嘉县",
                "label": "永嘉县"
            }, {
                "value": "平阳县",
                "label": "平阳县"
            }, {
                "value": "苍南县",
                "label": "苍南县"
            }, {
                "value": "文成县",
                "label": "文成县"
            }, {
                "value": "泰顺县",
                "label": "泰顺县"
            }, {
                "value": "瑞安市",
                "label": "瑞安市"
            }, {
                "value": "乐清市",
                "label": "乐清市"
            }]
        }, {
            "value": "嘉兴市",
            "label": "嘉兴市",
            "children": [{
                "value": "南湖区",
                "label": "南湖区"
            }, {
                "value": "秀洲区",
                "label": "秀洲区"
            }, {
                "value": "嘉善县",
                "label": "嘉善县"
            }, {
                "value": "海盐县",
                "label": "海盐县"
            }, {
                "value": "海宁市",
                "label": "海宁市"
            }, {
                "value": "平湖市",
                "label": "平湖市"
            }, {
                "value": "桐乡市",
                "label": "桐乡市"
            }]
        }, {
            "value": "湖州市",
            "label": "湖州市",
            "children": [
                {
                "value": "吴兴区",
                "label": "吴兴区",
                "children": [
                    {
                        "value": "织里镇",
                        "label": "织里镇"
                    },
                    {
                        "value": "八里店镇",
                        "label": "八里店镇"
                    },
                    {
                        "value": "龙泉街道",
                        "label": "龙泉街道"
                    }
                    ,
                    {
                        "value": "湖东街道",
                        "label": "湖东街道"
                    },
                    {
                        "value": "月河街道",
                        "label": "月河街道"
                    }
                    ,
                    {
                        "value": "埭溪镇",
                        "label": "埭溪镇"
                    },
                    {
                        "value": "朝阳街道",
                        "label": "朝阳街道"
                    }
                    ,
                    {
                        "value": "东林镇",
                        "label": "东林镇"
                    },
                    {
                        "value": "飞英街道",
                        "label": "飞英街道"
                    }
                    ,
                    {
                        "value": "环渚街道",
                        "label": "环渚街道"
                    },
                    {
                        "value": "爱山街道",
                        "label": "爱山街道"
                    }
                    ,
                    {
                        "value": "道场乡",
                        "label": "道场乡"
                    },
                    {
                        "value": "妙西镇",
                        "label": "妙西镇"
                    }
                ],
            }, {
                "value": "南浔区",
                "label": "南浔区",
                "children": [{
                    "value": "南浔镇",
                    "label": "南浔镇"
                },
                {
                    "value": "练市镇",
                    "label": "练市镇"
                },
                {
                    "value": "双林镇",
                    "label": "双林镇"
                },
                {
                    "value": "菱湖镇",
                    "label": "菱湖镇"
                },
                {
                    "value": "和孚镇",
                    "label": "和孚镇"
                },
                {
                    "value": "旧馆镇",
                    "label": "旧馆镇"
                }
                ,
                {
                    "value": "善琏镇",
                    "label": "善琏镇"
                },
                {
                    "value": "千金镇",
                    "label": "千金镇"
                },
                {
                    "value": "石淙镇",
                    "label": "石淙镇"
                }
            ],
            }, 
            
            
            {
                "value": "南太湖新区",
                "label": "南太湖新区"
            ,
            "children": [{
                "value": "杨家埠街道",
                "label": "杨家埠街道"
            },
            {
                "value": "仁皇山街道",
                "label": "仁皇山街道"
            },
            {
                "value": "康山街道",
                "label": "康山街道"
            },
            {
                "value": "凤凰街道",
                "label": "凤凰街道"
            },
            {
                "value": "滨湖街道",
                "label": "滨湖街道"
            },
            {
                "value": "龙溪街道",
                "label": "龙溪街道"
            }
            
        ],
            },{
                "value": "德清县",
                "label": "德清县"
    
                ,
                "children": [{
                    "value": "武康街道",
                    "label": "武康街道"
                },
                {
                    "value": "新市镇",
                    "label": "新市镇"
                },
                {
                    "value": "阜溪街道",
                    "label": "阜溪街道"
                },
                {
                    "value": "舞阳街道",
                    "label": "舞阳街道"
                },
                {
                    "value": "雷甸镇",
                    "label": "雷甸镇"
                },
                {
                    "value": "乾元镇",
                    "label": "乾元镇"
                }
                ,
                {
                    "value": "钟管镇",
                    "label": "钟管镇"
                },
                {
                    "value": "禹越镇",
                    "label": "禹越镇"
                },
                {
                    "value": "新安镇",
                    "label": "新安镇"
                },
                {
                    "value": "康乾街道",
                    "label": "康乾街道"
                },
                {
                    "value": "莫干山镇",
                    "label": "莫干山镇"
                }
    
                ,
                {
                    "value": "下渚湖街道",
                    "label": "下渚湖街道"
                },
                {
                    "value": "洛舍镇",
                    "label": "洛舍镇"
                }
                
            ],
            }, {
                "value": "长兴县",
                "label": "长兴县"
                ,
                "children": [{
                    "value": "雉城街道",
                    "label": "雉城街道"
                },
                {
                    "value": "龙山街道",
                    "label": "龙山街道"
                },
                {
                    "value": "太湖街道",
                    "label": "太湖街道"
                },
                {
                    "value": "泗安镇",
                    "label": "泗安镇"
                },
                {
                    "value": "和平镇",
                    "label": "和平镇"
                },
                {
                    "value": "煤山镇",
                    "label": "煤山镇"
                }
                ,
                {
                    "value": "洪桥镇",
                    "label": "洪桥镇"
                },
                {
                    "value": "林城镇",
                    "label": "林城镇"
                },
                {
                    "value": "画溪街道",
                    "label": "画溪街道"
                },
                {
                    "value": "夹浦镇",
                    "label": "夹浦镇"
                },
                {
                    "value": "虹星桥镇",
                    "label": "虹星桥镇"
                }
    
                ,
                {
                    "value": "李家巷镇",
                    "label": "李家巷镇"
                },
                {
                    "value": "小浦镇",
                    "label": "小浦镇"
                }
                ,
                {
                    "value": "吕山乡",
                    "label": "吕山乡"
                },
                {
                    "value": "水口乡",
                    "label": "水口乡"
                }
                
            ],
            }, {
                "value": "安吉县",
                "label": "安吉县"
    
    
                ,
                "children": [{
                    "value": "昌硕街道",
                    "label": "昌硕街道"
                },
                {
                    "value": "递铺街道",
                    "label": "递铺街道"
                },
                {
                    "value": "梅溪镇",
                    "label": "梅溪镇"
                },
                {
                    "value": "天子湖镇",
                    "label": "天子湖镇"
                },
                {
                    "value": "孝丰镇",
                    "label": "孝丰镇"
                },
                {
                    "value": "灵峰街道",
                    "label": "灵峰街道"
                }
                ,
                {
                    "value": "杭垓镇",
                    "label": "杭垓镇"
                },
                {
                    "value": "天荒坪镇",
                    "label": "天荒坪镇"
                },
                {
                    "value": "孝源街道",
                    "label": "孝源街道"
                },
                {
                    "value": "报福镇",
                    "label": "报福镇"
                },
                {
                    "value": "上墅乡",
                    "label": "上墅乡"
                }
    
                ,
                {
                    "value": "章村镇",
                    "label": "章村镇"
                },
                {
                    "value": "溪龙乡",
                    "label": "溪龙乡"
                }
                ,
                {
                    "value": "鄣吴镇",
                    "label": "鄣吴镇"
                },
                {
                    "value": "山川乡",
                    "label": "山川乡"
                }
                
            ],
            }]
        }, {
            "value": "绍兴市",
            "label": "绍兴市",
            "children": [{
                "value": "越城区",
                "label": "越城区"
            }, {
                "value": "柯桥区",
                "label": "柯桥区"
            }, {
                "value": "上虞区",
                "label": "上虞区"
            }, {
                "value": "新昌县",
                "label": "新昌县"
            }, {
                "value": "诸暨市",
                "label": "诸暨市"
            }, {
                "value": "嵊州市",
                "label": "嵊州市"
            }]
        }, {
            "value": "金华市",
            "label": "金华市",
            "children": [{
                "value": "婺城区",
                "label": "婺城区"
            }, {
                "value": "金东区",
                "label": "金东区"
            }, {
                "value": "武义县",
                "label": "武义县"
            }, {
                "value": "浦江县",
                "label": "浦江县"
            }, {
                "value": "磐安县",
                "label": "磐安县"
            }, {
                "value": "兰溪市",
                "label": "兰溪市"
            }, {
                "value": "义乌市",
                "label": "义乌市"
            }, {
                "value": "东阳市",
                "label": "东阳市"
            }, {
                "value": "永康市",
                "label": "永康市"
            }]
        }, {
            "value": "衢州市",
            "label": "衢州市",
            "children": [{
                "value": "柯城区",
                "label": "柯城区"
            }, {
                "value": "衢江区",
                "label": "衢江区"
            }, {
                "value": "常山县",
                "label": "常山县"
            }, {
                "value": "开化县",
                "label": "开化县"
            }, {
                "value": "龙游县",
                "label": "龙游县"
            }, {
                "value": "江山市",
                "label": "江山市"
            }]
        }, {
            "value": "舟山市",
            "label": "舟山市",
            "children": [{
                "value": "定海区",
                "label": "定海区"
            }, {
                "value": "普陀区",
                "label": "普陀区"
            }, {
                "value": "岱山县",
                "label": "岱山县"
            }, {
                "value": "嵊泗县",
                "label": "嵊泗县"
            }]
        }, {
            "value": "台州市",
            "label": "台州市",
            "children": [{
                "value": "椒江区",
                "label": "椒江区"
            }, {
                "value": "黄岩区",
                "label": "黄岩区"
            }, {
                "value": "路桥区",
                "label": "路桥区"
            }, {
                "value": "玉环县",
                "label": "玉环县"
            }, {
                "value": "三门县",
                "label": "三门县"
            }, {
                "value": "天台县",
                "label": "天台县"
            }, {
                "value": "仙居县",
                "label": "仙居县"
            }, {
                "value": "温岭市",
                "label": "温岭市"
            }, {
                "value": "临海市",
                "label": "临海市"
            }]
        }, {
            "value": "丽水市",
            "label": "丽水市",
            "children": [{
                "value": "莲都区",
                "label": "莲都区"
            }, {
                "value": "青田县",
                "label": "青田县"
            }, {
                "value": "缙云县",
                "label": "缙云县"
            }, {
                "value": "遂昌县",
                "label": "遂昌县"
            }, {
                "value": "松阳县",
                "label": "松阳县"
            }, {
                "value": "云和县",
                "label": "云和县"
            }, {
                "value": "庆元县",
                "label": "庆元县"
            }, {
                "value": "景宁畲族自治县",
                "label": "景宁畲族自治县"
            }, {
                "value": "龙泉市",
                "label": "龙泉市"
            }]
        }]
    },
]